import { filterCustomBetSelections } from '../api/api';
import { BetItem } from '../components/BettingSlipDrawer';

function formatOdds(val: string | number | undefined): string {
  if (val === undefined || val === null || val === '') return '';
  const n = parseFloat(String(val));
  if (isNaN(n) || n <= 1) return '';
  return n.toFixed(2).replace('.', ',');
}

export function customBetLabel(count: number): string {
  return `${count}er MatchKombi`;
}

interface RemoveOpts {
  locale?: string;
  onUpdateBet: (id: string, patch: Partial<BetItem>) => void;
  onRemoveBet: (id: string) => void;
}

/**
 * Drop one leg from an MK+ (CustomBet) slip item.
 *
 * A provider CustomBet group needs at least two selections, so removing down to
 * one leg removes the whole item. Otherwise the shortened group is re-priced
 * through /v1/custombet/events/{id}/filter — if that fails (e.g. signed out) we
 * clear the stored odds instead of keeping a stale price, so placement falls
 * back to the current provider price rather than a wrong accepted_odds.
 */
export async function removeCustomBetSelection(
  bet: BetItem,
  index: number,
  { locale, onUpdateBet, onRemoveBet }: RemoveOpts
): Promise<void> {
  const selections = bet.customBetSelections ?? [];
  const remaining = selections.filter((_, i) => i !== index);

  if (remaining.length < 2 || !bet.eventId) {
    onRemoveBet(bet.id);
    return;
  }

  const basePatch: Partial<BetItem> = {
    customBetSelections: remaining,
    tippLabel: customBetLabel(remaining.length),
    marketId: remaining[0].market_id,
    outcomeId: remaining[0].outcome_id,
    specifiers: remaining[0].specifiers,
  };

  try {
    const res = await filterCustomBetSelections(
      bet.eventId,
      {
        selections: remaining.map((s) => ({
          market_id: s.market_id,
          specifiers: s.specifiers,
          outcome_id: s.outcome_id,
        })),
      },
      { locale }
    );
    onUpdateBet(bet.id, { ...basePatch, odds: formatOdds(res.accepted_odds) });
  } catch {
    onUpdateBet(bet.id, { ...basePatch, odds: '' });
  }
}
